
import { useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";

import { Box, Typography, Divider, Stepper, Step, StepLabel, Stack, CircularProgress, Alert, Snackbar, Button } from "@mui/material"

import { LoadingButton } from "@mui/lab";

import CheckIcon from '@mui/icons-material/CheckCircle';

import AuthCode from 'react-auth-code-input';
import '../../css/InputCodeVerification.css';

import { login } from "../../store/slices/authSlice";

import { ObtenerPerfil } from "../../actions/admin/usuarioActions";

import { EnviarCodigoActivacionEmail, EnviarCodigoActivacionPhone, RegistrarTokenUnico, ValidarCodigoActivacionEmailPhone } from "../../actions/auth/authActions";

export const TokenUnico = ({ dialog }) => {    

    const authData = useSelector( state => state.auth );
    
    const dispatch = useDispatch();

    const [timer, setTimer] = useState( 0 );

    const [activeStep, setActiveStep] = useState( 0 );
    
    const [tipoEnvio, setTipoEnvio] = useState( 0 );

    const [codigoActivacion, setCodigoActivacion] = useState( '' );

    const [tokenActivacion, setTokenActivacion] = useState( '' );

    const [tokenUnico, setTokenUnico] = useState( '' );
    const [confirmarTokenUnico, setConfirmarTokenUnico] = useState( '' );

    const [loading, setLoading] = useState( true );
    
    const [loadingEnviarCodigoEmail, setLoadingEnviarCodigoEmail] = useState( false );
    const [loadingEnviarCodigoPhone, setLoadingEnviarCodigoPhone] = useState( false );

    const [loadingReenviarCodigos, setLoadingReenviarCodigos] = useState( false );
    const [loadingValidarCodigos, setLoadingValidarCodigos] = useState( false );
    const [loadingRegistrarTokenUnico, setLoadingRegistrarTokenUnico] = useState( false );
    const [loadingRegister, setLoadingRegister] = useState( false );

    const [usuario, setUsuario] = useState( {} );

    const [{ open, message, type }, setAlert] = useState({
        open: false,
        message: '',
        type: 'warning'
    });

    const handleEnviarCodigoActivacionEmail = async () => {

        setLoadingEnviarCodigoEmail( true );
        setTipoEnvio( 1 );

        await EnviarCodigoActivacionEmail().then( response => {

            if ( response ) {

                if ( response.status === 200 ) {

                    const { success, message, token } = response.data;

                    if( success ){

                        setTimeout(() => {
    
                            setTokenActivacion( token ?? '' );
                            setLoadingEnviarCodigoEmail( false );
                            setActiveStep( prev => prev + 1 );
    
                        }, 700);
                        
                    }
                    else{
                        
                        setTimeout(() => {
                            
                            setAlert({
                                open: true,
                                message: message,
                                type: 'error'
                            });
                        
                            setLoadingEnviarCodigoEmail( false );
    
                        }, 700);

                    }

                }
                else{          

                    setTimeout(() => {
                        
                        setLoadingEnviarCodigoEmail( false );

                    }, 700);

                }

            }

        });
    }

    const handleEnviarCodigoActivacionPhone = async () => {

        setLoadingEnviarCodigoPhone( true );
        setTipoEnvio( 2 );

        await EnviarCodigoActivacionPhone().then( response => {

            if ( response ) {

                if ( response.status === 200 ) {

                    const { success, message, token } = response.data;

                    if( success ){

                        setTimeout(() => {
    
                            setTokenActivacion( token ?? '' );
                            setLoadingEnviarCodigoPhone( false );
                            setActiveStep( prev => prev + 1 );
    
                        }, 700);
                        
                    }
                    else{
                        
                        setTimeout(() => {
                            
                            setAlert({
                                open: true,
                                message: message,
                                type: 'error'
                            });
                        
                            setLoadingEnviarCodigoPhone( false );
    
                        }, 700);

                    }

                }
                else{          

                    setTimeout(() => {
                        
                        setLoadingEnviarCodigoPhone( false );

                    }, 700);

                }

            }

        });
    }

    const handleReenviarCodigoActivacion = async () => {

        if( tipoEnvio === 1 ){

            setLoadingReenviarCodigos( true );
    
            await EnviarCodigoActivacionEmail().then( response => {
    
                if ( response ) {
    
                    if ( response.status === 200 ) {
    
                        const { success, message, token } = response.data;
    
                        if ( success ) {
    
                            setTimeout(() => {
                                
                                setTokenActivacion( token );
                                setLoadingReenviarCodigos( false );
                                setTimer( 15 );
        
                            }, 700);
    
                        }
                        else{          
    
                            setTimeout(() => {
                                
                                setAlert({
                                    open: true,
                                    message: message,
                                    type: 'error'
                                });
    
                                setLoadingReenviarCodigos( false );
        
                            }, 700);
    
                        }
    
                    }
                    else{          
    
                        setTimeout(() => {
                            
                            setLoadingReenviarCodigos( false );
    
                        }, 700);
    
                    }
    
                }
    
            });

        }
        else if( tipoEnvio === 2 ){

               setLoadingReenviarCodigos( true );
    
            await EnviarCodigoActivacionPhone().then( response => {
    
                if ( response ) {
    
                    if ( response.status === 200 ) {
    
                        const { success, message, token } = response.data;
    
                        if ( success ) {
    
                            setTimeout(() => {
                                
                                setTokenActivacion( token );
                                setLoadingReenviarCodigos( false );
                                setTimer( 15 );
        
                            }, 700);
    
                        }
                        else{          
    
                            setTimeout(() => {
                                
                                setAlert({
                                    open: true,
                                    message: message,
                                    type: 'error'
                                });
    
                                setLoadingReenviarCodigos( false );
        
                            }, 700);
    
                        }
    
                    }
                    else{          
    
                        setTimeout(() => {
                            
                            setLoadingReenviarCodigos( false );
    
                        }, 700);
    
                    }
    
                }
    
            });

        }

    }

    const handleValidarCodigoActivacion = async () => {

        setLoadingValidarCodigos( true );

        await ValidarCodigoActivacionEmailPhone({ codigoActivacion, tokenActivacion, idTipoEnvio: tipoEnvio }).then( response => {

            if ( response ) {

                if ( response.status === 200 ) {

                    const { success, message } = response.data;

                    if( success ){

                        setTimeout(() => {
    
                            setLoadingValidarCodigos( false );
                            setActiveStep( prev => prev + 1 );
    
                        }, 700);
                        
                    }
                    else {
                        
                        setTimeout(() => {
    
                            setAlert({
                                open: true,
                                message: message,
                                type: 'error'
                            });

                            setLoadingValidarCodigos( false );
    
                        }, 700);
                    }

                }
                else {
                        
                    setTimeout(() => {    
                        
                        setLoadingValidarCodigos( false );

                    }, 700);

                }

            }

        });
    }

    const handleRegistrarTokenUnico = async () => {

        setLoadingRegistrarTokenUnico( true );

        await RegistrarTokenUnico({ tokenUnico }).then( response => {

            if ( response ) {

                if ( response.status === 200 ) {

                    const { success, message } = response.data;

                    if( success ){
                        
                        if( !dialog ){    

                            setTimeout(() => {
    
                                setLoadingRegistrarTokenUnico( false );
                                setActiveStep( prev => prev + 1 );

                                const data = {
                                    ...authData,
                                    tokenUnicoActivado: true,
                                };                            
            
                                window.localStorage.setItem("data", JSON.stringify( data ) );
                                
                                dispatch( login( data ) );

                                
                            }, 700);

                        }
                        else{

                            setTimeout(() => {
    
                                setLoadingRegistrarTokenUnico( false );
                                setLoadingRegister( true );
                                setActiveStep( prev => prev + 1 );
                                
                            }, 700);
    
                            setTimeout(() => {
    
                                const data = {
                                    ...authData,
                                    tokenUnicoActivado: true,
                                };                            
            
                                window.localStorage.setItem("data", JSON.stringify( data ) );
                                
                                dispatch( login( data ) );
                                setLoadingRegister( false );
                                
                            }, 2000);

                        }
                        
                    }
                    else {
                        
                        setTimeout(() => {
    
                            setAlert({
                                open: true,
                                message: message,
                                type: 'error'
                            });

                            setLoadingRegistrarTokenUnico( false );
    
                        }, 700);
                    }

                }
                else {
                        
                    setTimeout(() => {    
                        
                        setLoadingRegistrarTokenUnico( false );

                    }, 700);

                }

            }

        });
    }

    useEffect(() => {

        async function Obtener() {

            await ObtenerPerfil().then(response => {

                if ( response ) {

                    if ( response.status === 200 ) {

                        setTimeout(() => {

                            setUsuario( response.data );
                            setLoading(false);

                        }, 700);

                    }

                }

            });

        }

        Obtener();

    }, [ ]);

    useEffect(() => {

        let timeout;

        if ( timer > 0 ) {

            timeout = setTimeout(() => {

                setTimer((time) => time - 1);

            }, 1000);

        }

        return () => clearTimeout( timeout )

    }, [ timer ])

    return (      

        <>

            <Snackbar open={ open } autoHideDuration={4000} onClose={ () => { setAlert({ open: false, message, type }) } } anchorOrigin={{ vertical : 'bottom', horizontal: 'center' }} >
                <Alert onClose={ () => { setAlert({ open: false, message, type }) } } variant='filled' severity={ type } sx={{ width: '100%' }}>
                    { message }
                </Alert>
            </Snackbar>

            <Box>

                <Typography variant="h5" fontWeight="bold" textAlign="center">
                    { authData?.tokenUnicoActivado ? 'Actualizar' : 'Activar' } token único
                </Typography>

                <Divider sx={{ mb: 6, mt: 2 }} />

                <Box sx={{ mb: 4 }}>

                    <Stepper activeStep={activeStep} alternativeLabel>

                        <Step>
                            <StepLabel>Indicaciones</StepLabel>
                        </Step>
                        <Step>
                            <StepLabel>Validar códigos de verificación</StepLabel>
                        </Step>
                        <Step>
                            <StepLabel>Registrar token único</StepLabel>
                        </Step>

                    </Stepper>

                </Box>

                {
                    activeStep === 0 
                    ?
                        loading
                        ?
                            <Stack gap={4}>

                                <Box sx={{ textAlign: 'center', height: 300 }} >
                                    <CircularProgress size={50} sx={{ color: '#000', mt: 15 }} />
                                </Box>

                            </Stack>
                        :
                            <Stack gap={4}>

                                <Typography variant="body1" fontWeight="bold" textAlign={'center'}>
                                    Activa tu token único para realizar operaciónes seguras desde Poder en Líne@ Web y Poder en Líne@ App
                                </Typography>

                                <Typography variant="body1" fontWeight="bold" textAlign={'center'}>
                                    Enviaremos un código de activación
                                </Typography>
                  
                                <Typography variant="body1" textAlign={'center'}>
                                    Para continuar necesitas tener a la mano el correo electrónico ó teléfono celular.
                                </Typography>

                                <Box textAlign={'center'}>                         

                                    <LoadingButton
                                        variant="contained"
                                        loading={ loadingEnviarCodigoEmail }
                                        onClick={ handleEnviarCodigoActivacionEmail }
                                        disabled={ loadingEnviarCodigoPhone }
                                    >
                                        Enviar correo electrónico a { usuario.correoElectronico }
                                    </LoadingButton>                                    

                                </Box>

                                <Box textAlign={'center'}>    

                                    <LoadingButton
                                        variant="contained"
                                        loading={ loadingEnviarCodigoPhone }
                                        onClick={ handleEnviarCodigoActivacionPhone }
                                        disabled={ loadingEnviarCodigoEmail }
                                    >
                                        Enviar mensaje de texto a { usuario.telefonoCelular }
                                    </LoadingButton>
                                                        
                                </Box>

                            </Stack>
                    :
                    
                    activeStep === 1
                    ?
                        <Stack gap={2}>

                            <Box sx={{ textAlign: 'center' }} >
                            
                                <Typography variant="body1" sx={{ my: 3 }}>
                                    Ingresa el código de activación.                              
                                </Typography>                     
                            
                                <AuthCode                 
                                    key={ 'codigoActivicion' }  
                                    inputClassName='input'   
                                    isPassword={ false }
                                    length={6} 
                                    onChange={ ( value ) => setCodigoActivacion( value ) } 
                                    autoFocus
                                />    

                            </Box>         

                            <Box textAlign={'center'} mt={3}>

                                <LoadingButton
                                    variant="contained"
                                    disabled={ codigoActivacion.length !== 6 }
                                    loading={ loadingValidarCodigos }
                                    onClick={ handleValidarCodigoActivacion }                                                
                                >
                                    Validar código de activación
                                </LoadingButton>
                            
                            </Box>

                            <Box textAlign={'center'} mt={1}>

                                <LoadingButton
                                    color="inherit"
                                    variant="contained"                      
                                    loading={ loadingReenviarCodigos }                          
                                    disabled={ timer !== 0 }
                                    onClick={ handleReenviarCodigoActivacion }
                                >                                                
                                    {
                                        ( timer !== 0 )
                                        ?
                                            `Reintentar en ${timer} `
                                        :
                                            'Reenviar código de activación'
                                    }
                                </LoadingButton>
                            
                            </Box>
                    
                            <Box textAlign={'center'} mt={1}>

                                <Button onClick={ () =>  setActiveStep( prev => prev - 1 ) }>                                                
                                    Regresar
                                </Button>
                            
                            </Box>

                        </Stack>
                    :

                    activeStep === 2
                    ?
                        <Stack gap={4}>

                            <Box sx={{ textAlign: 'center' }} >
                            
                                <Typography variant="body1" sx={{ my: 2 }}>
                                    Ingresa un token único de 4 digitos                      
                                </Typography>                     
                            
                                <AuthCode        
                                    key={ 'tokenUnico' }  
                                    inputClassName='input'   
                                    isPassword={ false }
                                    length={4} 
                                    onChange={ ( value ) => setTokenUnico( value ) } 
                                />    

                            </Box>
                            
                            <Box sx={{ textAlign: 'center' }} >
                            
                                <Typography variant="body1" sx={{ my: 2 }}>
                                    Confirma el token único.                    
                                </Typography>                     
                            
                                <AuthCode        
                                    key={ 'confirmarTokenUnico' }
                                    inputClassName='input'   
                                    isPassword={ false }
                                    length={4} 
                                    onChange={ ( value ) => setConfirmarTokenUnico( value ) } 
                                />    

                            </Box>

                            <Box textAlign={'center'}>

                                <LoadingButton
                                    variant="contained"
                                    disabled={ tokenUnico !== confirmarTokenUnico || tokenUnico.length !== 4 || confirmarTokenUnico.length !== 4 }
                                    loading={ loadingRegistrarTokenUnico }
                                    onClick={ handleRegistrarTokenUnico }
                                >
                                    Registrar token único
                                </LoadingButton>
                            
                            </Box>

                            <Typography variant="body1" color='text.secondary' textAlign={'center'}>
                                * El token único ofrece un nivel de seguridad para tus operaciones.'
                            </Typography>

                        </Stack>
                    :

                        <Stack gap={3}>

                            <Box sx={{ textAlign: 'center' }}>
                                <CheckIcon sx={{ fontSize: '7em' }} color='success' />
                            </Box>

                            <Typography variant="h6" fontWeight="bold" textAlign={'center'}>                                            
                                Token único activado.
                            </Typography>
                            
                            <Typography variant="body1" color='text.secondary' textAlign={'center'}>
                                Ya esta activo el token único para poder realizar operaciones seguras desde Poder en Líne@ Web y Poder en Líne@ App
                            </Typography>

                            {
                                loadingRegister
                                &&
                                    <Box sx={{ textAlign: 'center' }}>

                                        <CircularProgress size={40} sx={{ mt: 2, mb: 2 }} />

                                    </Box>
                            }

                        </Stack>
                }

            </Box>        
        
        </>
                  
    )
}